export const singlePetSuccessMessage = (label = 'details') => {
  return `Thanks, your ${label} will be updated. Please refresh your page in a moment to view the changes.`;
};
